import { Button } from "@/components/ui/button";
import { PlusCircle, LogOut } from "lucide-react";
import { LogoutOptions } from "@auth0/auth0-react";

interface HeaderProps {
  onNavigate: () => void;
  onLogout: (options?: LogoutOptions) => void;
}

export function OrganizationsHeader({ onNavigate, onLogout }: HeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-3xl font-bold text-center sm:text-left text-[#050505]">
          Suas organizacoes
        </h1>
        <p className="text-sm text-[#050505]/70 text-center sm:text-left mt-1">
          Crie uma nova organizacao ou entre na sua conta atual.
        </p>
      </div>

      <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
        <Button
          className="w-full sm:w-auto h-11 px-5 gap-2 rounded-xl bg-gradient-to-r from-[#EE7B11] to-[#f59642] hover:from-[#d96e0f] hover:to-[#e58a3d] text-white shadow-md hover:shadow-lg transition-all"
          onClick={onNavigate}
        >
          <PlusCircle className="h-5 w-5" />
          <span className="font-semibold">Nova organização</span>
        </Button>

        <Button
          variant="outline"
          className="w-full sm:w-auto h-11 px-5 gap-2 rounded-xl border-[#050505]/20 text-[#050505] hover:bg-[#050505]/5"
          onClick={() =>
            onLogout({
              logoutParams: { returnTo: window.location.origin },
            })
          }
        >
          <LogOut className="h-5 w-5" />
          <span className="font-medium">Sair da aplicação</span>
        </Button>
      </div>
    </div>
  );
}
